module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" class="header-wrap" data-toggle="expand-spoiler"><header><h5 class="module-title">'+
((__t=( i18n.tc( "ControlSettings", "Settings" )))==null?'':__t)+
'</h5><i class="icon icon-material icon-expand"></i></header></a><div class="expand-spoiler';
 if ( isOpen ) { 
__p+=' open';
 } 
__p+='" data-container="expand-spoiler"><div class="expand-content"><div><nav class="module-menu"><ul> ';
 if (hasUnitControlAccess) { 
__p+=' <li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-alias">'+
((__t=( i18n.tc( "ControlSettings", "Alias" ) ))==null?'':__t)+
'</a></li> ';
 if (isHome) { 
__p+=' <li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-location">'+
((__t=( i18n.tc( "ControlSettings", "Location" ) ))==null?'':__t)+
'</a></li><li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-alarmSwitches">'+
((__t=( i18n.tc( "ControlSettings", "Alarm Settings" ) ))==null?'':__t)+
'</a></li><li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-dayAndNight">'+
((__t=( i18n.tc( "ControlSettings", "Day And Night" ) ))==null?'':__t)+
'</a></li> ';
 } 
__p+=' ';
 if (isPro) { 
__p+=' <li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-gpai">'+
((__t=( i18n.tc( "ControlSettings", "General alarm input" ) ))==null?'':__t)+
'</a></li> ';
 }} 
__p+=' ';
if ( hasSubscription && isOwner ) { 
__p+=' <li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-subscription">'+
((__t=( i18n.tc( "ControlSettings", "Subscription" ) ))==null?'':__t)+
'</a></li> ';
 } 
__p+=' <li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-details">'+
((__t=( i18n.tc( "ControlSettings", "Details" ) ))==null?'':__t)+
'</a></li> ';
 if ( isAutomotive && hasUnitControlAccess ) { 
__p+=' <li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-vehicle">'+
((__t=( i18n.tc( "ControlSettings", "Vehicle" ) ))==null?'':__t)+
'</a></li> ';
 } 
__p+=' ';
 if( !hasSubscription ) { 
__p+=' <li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-install">'+
((__t=( i18n.tc("ControlSettings", "Install") ))==null?'':__t)+
'</a></li> ';
 } 
__p+=' </ul></nav></div> ';
 if( showInstall ) { 
__p+=' <div><h5>'+
((__t=( i18n.tc( "ControlSettings", "Installer settings" ) ))==null?'':__t)+
'</h5><nav class="module-menu"><ul><li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-retest">'+
((__t=( i18n.tc( "ControlSettings", "Retest" ) ))==null?'':__t)+
'</a></li> ';
 if(isHome && !hasSubscription && (isTechSupport || isCurrentInstaller) && !isConfiguring) { 
__p+=' <li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-configure">'+
((__t=( i18n.tc( "ControlSettings", "Configure" ) ))==null?'':__t)+
'</a></li> ';
 } 
__p+=' ';
 if( hasSubscription) { 
__p+=' <li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-complaint">'+
((__t=( i18n.tc( "ControlSettings", "Complaint" ) ))==null?'':__t)+
'</a></li> ';
 } 
__p+=' ';
 if ( isTechSupport && !hasSubscription ) { 
__p+=' <li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-reset-metadata">'+
((__t=( i18n.tc( "ControlSettings", "Reset metadata" ) ))==null?'':__t)+
'</a></li> ';
 } 
__p+=' </ul></nav></div> ';
 } 
__p+=' <div><em><small style="display: block; padding: 0.25rem;">Image control would need a web-interface as well as hooks for native image/camera control.</small></em></div></div></div>';
}
return __p;
};
